<template>
  <b-list-group-item v-if="project.deleted_at">
    <h2 class="h5 d-flex justify-between align-items-start mb-1">
      <div class="">
        <small class="d-block">{{ project.project_number }}</small>

        {{ project.name }}
      </div>
      <b-badge pill variant="info">
        {{ $t(project.status) }}
      </b-badge>
    </h2>

    <small class="text-muted d-block mb-3">
      {{ $t('Created at: :date', {date: $moment(project.created_at).format('lll')}) }}
      <br>
      {{ $t('Deleted at: :date', {date: $moment(project.deleted_at).format('lll')}) }}
      <br>
      {{ $t('Deleted by: :user', {user: project.deleted_by}) }}
    </small>

    <b-form @submit.prevent="handleRestore">
      <b-btn :disabled="restoring" size="sm" type="submit">
        {{ $t('Restore') }}
      </b-btn>
    </b-form>
  </b-list-group-item>

  <b-list-group-item v-else>
    <b-row>
      <b-col cols="12">
        <b-link
            :to="{ name: 'projects.show', params: { projectId: project.id } }"
            class="d-inline-block w-100"
            tabindex="0"
        >
          <small>{{ project.project_number }}</small>
          <b-badge class="float-right" pill variant="info">
            {{ $t(project.status) }}
          </b-badge>
          <h2 class="h5 d-flex justify-between align-items-start mb-1">
            <div class="">
              {{ project.name }}
            </div>
          </h2>
        </b-link>
      </b-col>
      <b-col>
        <small class="text-muted">
          {{ $t('Created at: :date', {date: $moment(project.created_at).format('lll')}) }}
          <br>
          {{ $t('Last update: :date', {date: $moment(project.updated_at).format('lll')}) }}
        </small>
      </b-col>
      <b-col
          :id="`project_${project.id}_list_item`"
          class="align-self-end project-tooltip"
          cols="auto"
      >
        <b-button
            :id="'last-action-of-' + value.id"
            class="py-0 float-right"
            pill
            size="sm"
            variant="outline-info"
            @focus="getLastAction"
        >
          <fa icon="info" />
        </b-button>
        <b-tooltip
            :target="'last-action-of-' + value.id"
            :container="`project_${project.id}_list_item`"
            placement="right"
            style="opacity: 1"
            triggers="click"
            variant="info"
        >
          <spinner v-if="pending" />
          <b-row v-for="recentAction in recentActions"
                 v-else
                 :key="recentAction.id"
                 class="align-items-center border-left my-2 ml-1 no-gutters pl-2 row"
          >
            <b-col cols="auto" v-html="recentAction.created_at" />
            <b-col class="text-left px-4" cols="auto">
              <span v-html="recentAction.message" />
            </b-col>
          </b-row>
        </b-tooltip>

        <b-dropdown
            v-if="project.copies && project.copies.length"
            :text="$t('Copies')"
            class="d-block mt-3"
        >
          <b-dropdown-item
              v-for="copy in project.copies"
              :key="copy.id"
              :to="{ name: 'projects.show', params: { projectId: copy.id } }"
          >
            {{ $moment(copy.created_at).format('lll') }}
          </b-dropdown-item>
        </b-dropdown>
      </b-col>
    </b-row>
  </b-list-group-item>
</template>
<script>
import Spinner from "@/components/Spinner";

export default {
  name: 'ProjectsListItem',
  components: {Spinner},
  props: {
    value: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      project: {},
      restoring: false,
      recentActions: [],
      pending: false,
    }
  },
  watch: {
    value: {
      handler(value) {
        this.project = value
      },
      immediate: true
    }
  },
  methods: {
    getLastAction() {
      if (this.recentActions.length === 0) {
        this.pending = true;

        this.axios
            .get('/api/projects/' + this.value.id + '/logs/recent')
            .then(function (data) {
              for (const recentAction of data.data || data) {
                this.recentActions.push({
                  'message': recentAction.message,
                  'created_at': this.$moment(recentAction.created_at).format('lll')
                })
              }
            }.bind(this))
            .catch(e => {
              if (!e.response) {
                throw e;
              }
            })
            .finally(() => {
              this.pending = false;
            });
      }
    },
    handleRestore() {
      this.restoring = true;

      this.axios.post(`/api/projects/${this.project.id}/restore`).then(({data}) => {
        this.project = data;
      }).catch(e => e.respone || throw e)
          .finally(() => this.restoring = false)
    }
  }
};
</script>

<style scoped>

.project-tooltip >>> .tooltip-inner {
  max-width: 500px !important;
  width: 400px !important;
}
</style>
